import React, { useState } from "react";
import { enqueueSnackbar } from "notistack";
import { Modal3 } from "../../../../../components/DIsplay/Modal/Modal3";
import Button1 from "../../../../../components/form/Button1";
import approveTicket from "../../../../../controllers/booking/Ticket/approveTicket";

function ManageOrderApproveTicketRequest({ modal, setModal, booking }) {
  const [loading, setLoading] = useState(false);

  async function handleApprove() {
    const reqBody = {
      ticketQueueId: booking?._id,
    };
    setLoading(true);
    const res = await approveTicket(reqBody).finally(() => setLoading(false));

    if (res.return) {
      enqueueSnackbar("Ticket request has been approved.", {
        variant: "success",
      });
      setTimeout(() => {
        window.location.reload();
      }, 300);
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }

  return (
    <div>
      <Modal3
        open={modal?.approve}
        setOpen={(modalState) => setModal({ ...modal, approve: modalState })}
        title={"Confirm Ticket Issuance"}
      >
        <div className="max-w-[500px]">
          <div className="p-4">
            <p>
              Are you sure you want to approve the issuance of this ticket? This
              action cannot be undone.
            </p>
          </div>
          <div className="flex gap-4 p-4">
            <Button1
              variant="text"
              onClick={() => setModal({ ...modal, approve: false })}
            >
              Cancel
            </Button1>
            <Button1 loading={loading} onClick={() => handleApprove()}>
              Confirm
            </Button1>
          </div>
        </div>
      </Modal3>
    </div>
  );
}

export default ManageOrderApproveTicketRequest;
